<script lang="ts">
  import type { Snippet } from "svelte"

  const { children = null }: { children?: Snippet | null } = $props()
</script>

<div class="workflow-step-frame">
  {@render children?.()}
</div>

<style lang="less">
  .workflow-step-frame {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 0.8rem 0 1rem;
  }
</style>
